import React from 'react'
import './portfolio.css'
// import IMG1 from '../../assets/openMeetingToolkit.jpg'
import IMG1 from '../../assets/nyka.JPG'
import IMG2 from '../../assets/KooApp.png'
import IMG3 from '../../assets/weather.JPG'
import IMG4 from '../../assets/sudoku.JPG'
import {AiFillHtml5} from 'react-icons/ai'
import {FaJava,FaReact} from 'react-icons/fa'
import {SiJavascript,SiChakraui,SiRedux,SiExpress,SiMongodb,SiPostman,SiAlwaysdata} from 'react-icons/si'
import {IoLogoCss3,IoLogoNodejs} from 'react-icons/io'
import { ImGit,ImNpm }  from "react-icons/im"; 
import { CgListTree  }  from "react-icons/cg";

export default function Portfolio() {
  return (
    /* can put all projects into an array and dynamically display them in the future- 2:17 */
    <section id="projects">
      <h5>My Work</h5>
      <h2>Portfolio</h2>
      <div className="container portfolio__container">
        {/* Project 1 */}
        <article className='portfolio__item project-card' >
          <div className='portfolio__item-image'>
            <img src={IMG1} width = "480" height = "330"alt="nyka" />
          </div>
          <h3 class="project-title project-description" >Nykaa-clone</h3>
          <p class="pd">An Indian e-commerce platform that specializes in beauty and wellness. Login, signup, filter, cart, wishlist, payment, order, Invoice and logout functionality has developed.</p>
          <br/><br/>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/syed2605/Nykaa-clone" className='btn' target="_blank" rel="noreferrer" class="project-github-link">Github</a>
            <a href="https://nyka2605.netlify.app" className='btn btn-primary' target="_blank" rel="noreferrer" class="project-deployed-link">Live Demo</a>
          </div>
          <div className='portfolio__item-cta' style={{alignItems:"center",paddingRight:"15px"}}>
            <p>Tools Used :</p>
            <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://uploads-ssl.webflow.com/62038ffc9cd2db4558e3c7b7/6242e5dd4337267623f1e7a5_js.svg" className='mongoose about__icon skills-card-img'/> </article>
          </div>
        </article>
        {/* Project 2 */}
        <article className='portfolio__item project-card'>
          <div className='portfolio__item-image'>
            <img src={IMG2} alt="koo" />
          </div>
          <h3 class="project-title project-description">KooApp-clone</h3>
          <p class="pd">An Indian social media platform that allows users to share their thoughts and opinions, as well as share images and videos. Login, signup, feed, follow, followerposts, userposts, likes, creating posts and logout functionality has developed.</p><br/>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/syed2605/kooapp-clone" className='btn' target="_blank" rel="noreferrer" class="project-github-link">Github</a>
            <a href="https://kooapp-clone-deploy.vercel.app/" className='btn btn-primary' target="_blank" rel="noreferrer" class="project-deployed-link">Live Demo</a>
          </div>
          <div className='portfolio__item-cta ' style={{alignItems:"center"}}>
            <p>Tools Used : </p>
            <div className='frcs'>
            <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://uploads-ssl.webflow.com/62038ffc9cd2db4558e3c7b7/6242e5dd4337267623f1e7a5_js.svg" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://softprodigy.com/wp-content/uploads/2019/06/react-js.png" className='mongoose about__icon skills-card-img'/> </article>
              <article>  <img src="https://cdn.iconscout.com/icon/free/png-256/free-redux-283024.png" className='mongoose about__icon skills-card-img'/></article>
              <article><img src="https://www.happylifecreators.com/wp/wp-content/uploads/2022/06/chakra-ui_title2-400x400.png" className='mongoose about__icon skills-card-img'/></article>
              <article><img src="https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/node-512.png" className='mongoose about__icon skills-card-img'/></article>
              <article><img src="https://adware-technologies.s3.amazonaws.com/uploads/technology/thumbnail/20/express-js.png" className='mongoose about__icon skills-card-img'/></article>
              <article>  <img src="https://mongoosejs.com/docs/images/mongoose5_62x30_transparent.png" className='mongoose about__icon skills-card-img'/></article>
              <article> <img src="https://www.svgviewer.dev/static-svgs/34566/mongodb.svg" className='mongoose about__icon skills-card-img'/></article>
            </div>
          </div>
        </article>
        {/* Project 3 */}
        <article className='portfolio__item project-card'>
          <div className='portfolio__item-image'>
            <img src={IMG3} width = "480" height = "430" alt="weather" />
          </div>
          <h3 class="project-title project-description">Weather App</h3>
          <p class="pd">A simple weather app that get weather forecast of five days for your location & also search by a city.</p><br/>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/syed2605/WeatherApp" className='btn' target="_blank" rel="noreferrer" class="project-github-link">Github</a>
            <a href="https://weather2605.netlify.app" className='btn btn-primary' target="_blank" rel="noreferrer" class="project-deployed-link">Live Demo</a>
          </div>
          <div className='portfolio__item-cta' style={{alignItems:"center"}}>
            <p>Tools Used : </p>
            <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://uploads-ssl.webflow.com/62038ffc9cd2db4558e3c7b7/6242e5dd4337267623f1e7a5_js.svg" className='mongoose about__icon skills-card-img'/> </article>
          </div>
        </article>
        {/* Project 4 */}
        <article className='portfolio__item project-card'>
          <div className='portfolio__item-image'>
            <img src={IMG4} width = "480" height = "430" alt="Sudoku" />
          </div>
          <h3 class="project-title project-description">Sudoku-Puzzle</h3>
          <p class="pd">A simple algorithm-based application created for users who loves solving sudoku</p><br/>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/syed2605/Sudoku-Puzzle" className='btn' target="_blank" rel="noreferrer" class="project-github-link">Github</a>
            <a href="https://sudoku-puzzle-2605.netlify.app" className='btn btn-primary' target="_blank" rel="noreferrer" class="project-deployed-link">Live Demo</a>
          </div>
          <div className='portfolio__item-cta' style={{alignItems:"center"}}>
            <p>Tools Used : </p>
            <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582748_640.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://cdn.pixabay.com/photo/2017/08/05/11/16/logo-2582747_960_720.png" className='mongoose about__icon skills-card-img'/> </article>
              <article> <img src="https://uploads-ssl.webflow.com/62038ffc9cd2db4558e3c7b7/6242e5dd4337267623f1e7a5_js.svg" className='mongoose about__icon skills-card-img'/> </article>
          </div>
        </article>
      </div>
    </section>
  )
}
